import { Input, Select, TextArea, FilterPanel, Switch } from "@aidkitorg/component-library";
import React from "react";
import { useLocalizedStrings } from "../../../Localization";
import { useAggregationOptions } from "../hooks/useAggregationOptions";
import { useFieldOptions } from "../../hooks/useFieldOptions";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useSettingsFilterFields } from "../../Filters/hooks/useSettingsFilterFields";
import { useFieldValueSuggestions } from "../../shared/hooks/useFieldValueSuggestions";

export type PieChartFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,

  groupDataField: string,
  setGroupDataField: (val: string) => void,

  aggregation: string,
  setAggregation: (val: string) => void,

  dataField: string,
  setDataField: (val: string) => void,

  filterConfig?: ReportFilterConfig,
  setFilterConfig: (val: ReportFilterConfig | undefined) => void,

  showPercentages: boolean,
  setShowPercentages: (val: boolean) => void,

  setTitleHasError: (val: boolean) => void,
}

export const PieChartFormFields: React.FC<PieChartFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  groupDataField, setGroupDataField,
  aggregation, setAggregation,
  dataField, setDataField,
  filterConfig,
  setFilterConfig,
  showPercentages,
  setShowPercentages,
  setTitleHasError,
}) => {
  const L = useLocalizedStrings()
  const {aggregationOptions, getAggregationOption} = useAggregationOptions()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions()
  const availableFieldsForFilters = useSettingsFilterFields()
  const { fetchSuggestions } = useFieldValueSuggestions()

  return <>
    <div className="w-[300px] flex flex-col gap-y-2">

      <Input
        required
        maxLength={100}
        label={L.admin_panel.dashboards.chart_title}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onValidationChange={setTitleHasError}
      />

      <Select
        portal
        required
        virtualized
        sort
        options={fieldOptions}
        label={L.admin_panel.dashboards.group_by}
        description={L.admin_panel.dashboards.group_by_description}
        labelLocation="above"
        value={getSelectedFieldOption(groupDataField)}
        onChange={(value) => {
          if (value) setGroupDataField(value.value)
        }}
        placeholder={L.admin_panel.dashboards.x_axis_placeholder}
        searchable
      />
    
    </div>
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700">
        {L.admin_panel.dashboards.chart_values}
      </label>
      <div className="text-sm text-gray-600 bg-gray-50 p-3 rounded-md border">
        📊 <strong>{L.admin_panel.dashboards.applicant_count}</strong> - {L.admin_panel.dashboards.applicant_count_pie_chart_desc}
      </div>
    </div>
    <Switch
      size="sm"
      label={L.admin_panel.dashboards.show_percentages}
      checked={showPercentages}
      onCheckedChange={setShowPercentages}
    />

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {L.admin_panel.dashboards.filters_label}
      </label>
      <FilterPanel
        value={filterConfig}
        onChange={setFilterConfig}
        availableFields={availableFieldsForFilters}
        instanceId="pie-chart-form-filters"
        fetchFieldValues={fetchSuggestions}
        inline
      />
    </div>

    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}